import { Autocomplete, Box, Button, Stack, Tab, Tabs, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { AppointmentCard, CommonGridToolBarWithExtraFilter, CommonPatientDetails } from '../../Components/Common Components/CommonComponents'
import { DataGrid } from "@mui/x-data-grid";
import { Colors } from '../../Styles/Colors';
import { ImagePaths } from '../../Utility/ImagePaths';
import { useHistory, useLocation } from 'react-router-dom'
import { hasAccess } from '../../Utility/AccessUtils';
import { clearCachevalue, setCachevalue } from '../../Utility/Services/CacheProviderService';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import Loader from '../../Components/Loader';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTime } from "luxon";
import { ContentInTooltip } from '../../Components/CommonFunctions/CommonFunctions';


const RtTherapist = (props) => {
    const history = useHistory();
    const location = useLocation();
    
    // Get role from localStorage for access check
    const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserInfo') || '{}');
    const role = loggedInUserInfo?.is_user ? 'user' : 'admin';
    
    // Check if screen is locked using hasAccess
    const accessResult = hasAccess(null, role, location.pathname);
    const isScreenLocked = accessResult?.locked === true;
    
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [SchedulerDataList, setSchedulerDataList] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [selectedTherapy, setselectedTherapy] = useState(null);
    const [selectedStatus, setselectedStatus] = useState("pending");
    const [FilterDate, setFilterDate] = useState(new Date());
    const [TherapyMaster, setTherapyMaster] = useState([]);
    const [statusCount, setStatusCount] = useState(null);


    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
        setisloader(false)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
        setisloader(false)
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    useEffect(() => {
        GetTherapyMasters();
    }, [])

    useEffect(() => {
        GetTherapistDataList()
    }, [selectedTherapy, selectedStatus, FilterDate])

    const GetTherapistDataList = () => {
        setisloader(true)
        let DateFilterKey = FilterDate ? DateTime.fromJSDate(new Date(FilterDate)).toFormat('yyyy-MM-dd') : ""
        RestAPIService.getAll(Serviceurls.RT_THERAPIST_LIST + `?status=${selectedStatus}&therapy_id=${selectedTherapy?.id || ""}&date=${DateFilterKey}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    setStatusCount(response.data || {})
                    setSchedulerDataList(response.data.data || []);
                    setisloader(false)
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetTherapyMasters = () => {
        RestAPIService.getAll(Serviceurls.RADIO_THERAPY_GET)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyMaster(response.data.data || []);
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const postStatusData = (Data, Status) => {
        try {
            let data = {
                'status': Status,
                "radiotherapy_session_id": Data?.id
            }
            setisloader(true)
            RestAPIService.updateWithOutId(data, Serviceurls.RT_SCHEDULER_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        GetTherapistDataList()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const tableView = () => {
        try {
            const gridToolBar = () => {
                return (
                    <Box>
                        <CommonGridToolBarWithExtraFilter />
                    </Box>
                )
            }
            SchedulerDataList?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: 'patient_names', headerName: 'Patient Details', flex: 0.15,
                    renderCell: (params) => (<Box component={'div'}>{<CommonPatientDetails data={params?.row} />}</Box>
                    ), valueGetter: (params) => {
                        const name = params.row?.patient_names || "";
                        const mobile = params.row?.mobile_number || "";
                        const UHID = params.row?.patient_uhid || "";
                        return `${name} ${mobile} ${UHID}`;
                    }
                },
                {
                    field: 'tag_name', headerName: 'RT Tag', flex: 0.1,
                    renderCell: (params) => (params.row.tag_name ? ContentInTooltip(params.row.tag_name, 20) : '')
                },
                {
                    field: 'doctor_name', headerName: 'Doctor Details', flex: 0.1,
                    renderCell: (params) => (params.row.doctor_name ? ContentInTooltip(params.row.doctor_name, 20) : '-')
                },
                {
                    field: 'region_name', headerName: 'Region', flex: 0.10,
                    renderCell: (params) => (params.row.region_name ? ContentInTooltip(params.row.region_name, 15) : '-')
                },
                {
                    field: 'therapy_name', headerName: 'Therapy Details', flex: 0.10,
                    renderCell: (params) => (params.row.therapy_name ? ContentInTooltip(params.row.therapy_name, 15) : '-')
                },
                {
                    field: 'stimulator_name', headerName: 'Simulation Type', flex: 0.10,
                    renderCell: (params) => (params.row.stimulator_name ? ContentInTooltip(params.row.stimulator_name, 15) : '-')
                },
                {
                    field: 'credit_type', headerName: 'Credit Type', flex: 0.10,
                    renderCell: (params) => (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                            <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.9vw"}>{params?.row?.credit_type ? params?.row?.credit_type : "-"}</Typography>
                            <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.8vw"} >{params?.row?.credit_type === "Corporate credit" ? ContentInTooltip(params?.row?.company_name, 15) : params?.row?.credit_type === "Insurance credit" ? ContentInTooltip(params?.row?.insurance_company_name, 15) : ""}</Typography>
                        </Box>)
                },
                {
                    field: 'status', headerName: 'Status', flex: 0.1,
                    renderCell: (params) => {
                        let theraphyStatus = params?.row?.session_status
                        let divColor = params?.row?.session_status === "Completed" ? "#ECFFE9" : params?.row?.session_status === "Cancelled" ? "#FFE9E9" : (params?.row?.session_status === "Scheduled" || params?.row?.session_status === "Arrived" || params?.row?.session_status === "With Therapist" || params?.row?.session_status === "Pending") ? "#FFEFD8" : null;
                        let txtColor = params?.row?.session_status === "Completed" ? "#1E972A" : params?.row?.session_status === "Cancelled" ? "#B82121" : (params?.row?.session_status === "Scheduled" || params?.row?.session_status === "Arrived" || params?.row?.session_status === "With Therapist" || params?.row?.session_status === "Pending") ? "#dc8400" : null;
                        return (
                            <Stack sx={{ paddingX: "0.4vw", paddingY: "0.2vw", borderRadius: "0.2vw", backgroundColor: divColor, border: `1px solid ${txtColor}`, width: '10vw', textAlign: 'center' }}>
                                <Typography sx={{ color: txtColor, fontSize: "0.9vw" }}>{theraphyStatus ? theraphyStatus : "-"}</Typography>
                            </Stack>

                        );
                    }
                },
                {
                    field: 'action', headerName: 'Action', headerAlign: "center", flex: 0.05, align: "center",
                    renderCell: (params) => (<Box component={'div'}>
                        <Tooltip title={"View & Update"} placement="top" arrow>
                            <Button
                                onClick={() => {
                                    setCachevalue(JSON.stringify(params.row), "RtTherapistPatientData")
                                    history.push({ pathname: "/RadiotherapyTherapist/TherapySession", states: { TherapyDetailId: params?.row?.patient_therapy_id } })
                                }}
                                className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                <img src={ImagePaths.StoreViewButton.default} alt="view" style={{ width: '1.5vw', height: '1.5vw' }} />
                            </Button>
                        </Tooltip>
                    </Box>)
                },
            ];
            return (
                <Box sx={{ height: '64vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        rows={SchedulerDataList || []}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={page}
                        pageSize={pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        density='comfortable'
                        disableSelectionOnClick
                        loading={isloader}
                        rowHeight={60}
                        
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    // Show lock screen for admin if screen is locked
    if (role === 'admin' && isScreenLocked) {
        return (
            <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <img src={ImagePaths.LockScreen.default} alt="Lock" />
                <Typography sx={{ marginTop: '1vw', fontSize: '1.2vw', fontWeight: 600 }}>This feature is locked.</Typography>
                <Typography sx={{ marginTop: '0.5vw', fontSize: '0.9vw', color: '#666' }}>Please contact your administrator to unlock this feature.</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <div className='eMed_OP_AptHead'>
                <Box>
                    <Tabs
                        value={"Therapist"}
                        className='eMed_bill_Tab'
                    >
                        <Tab value="Therapist" label="Therapist" className='eMed_tab_header eMed_bill_Tab' />
                    </Tabs>
                </Box>

                <div className='eMed_Header_OP_home_div'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={FilterDate ? FilterDate : null}
                            name={"datePicker"}
                            inputFormat='DD-MM-YYYY'
                            views={["year", "month", "day"]}
                            onChange={(newDate) => {
                                setFilterDate(newDate);
                            }}
                            renderInput={(params) => <TextField
                                {...params}
                                label={"Date"}
                                variant="outlined"
                                onKeyDown={(e) => e.preventDefault()}
                                sx={{ width: '15dvw', marginLeft: '1vw' }}
                                size='small'
                            />}
                        />
                    </LocalizationProvider>
                </div>
            </div>
            <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
                <Box display={'flex'} justifyContent={'flex-start'} flexDirection={'row'} alignItems={'center'}>
                    <Autocomplete
                        size='small'
                        sx={{ width: '20vw', marginLeft: '1vw' }}
                        options={TherapyMaster}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option.therapy_name}
                        value={selectedTherapy}
                        onChange={(e, value) => {
                            setselectedTherapy(value)
                        }}
                        renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Therapy"} />}
                    />
                </Box>
                <Box className='eMed_OP_Apt_Cards'>
                    <AppointmentCard onClick={() => { setselectedStatus("") }} count={statusCount?.total_count || 0} label={"All"} color={"#04B7B1"} isSelectedCard={selectedStatus === "" ? true : false} />
                    <AppointmentCard onClick={() => { setselectedStatus("pending") }} count={statusCount?.total_pending_count || 0} label={"Pending"} color={"#AF2591"} isSelectedCard={selectedStatus === "pending" ? true : false} />
                    <AppointmentCard onClick={() => { setselectedStatus("completed") }} count={statusCount?.total_completed_count || 0} label={"Completed"} color={"#1E972A"} isSelectedCard={selectedStatus === "completed" ? true : false} />
                </Box>
            </Box>
            <Box>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    )
}

export default RtTherapist